import React, { useEffect, useState, useCallback } from 'react';
import { textFilter } from 'react-bootstrap-table2-filter';
import { connect } from 'react-redux';
import { getAllAlarmsXYWithIdProject } from 'services/api';
import AttenteRequete from '../../../hoc/AttenteRequete/AttenteRequete';
import Bouton from '../../UI/Bouton/Bouton';
import Tableau from '../../UI/tableau/Tableau';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import * as privilege from '../../../ressources/glossaires/glossaire_privileges';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import { VscNewFile, VscRefresh, VscSearch } from 'react-icons/vsc';

const TableauAlarmeXY = (props) => {
  const tableConfig = {
    columns: [
      // liste des clés pour l'entête du tableau de alarme
      {
        dataField: 'alarm_xy_id',
        text: [
          checkMot('id'),
          <Bouton
            type={type_btn.lupeSearch}
            cliquer={() => afficherFiltre('alarm_xy_id', checkMot('id'))}
          >
            <VscSearch size={10} />
          </Bouton>,
        ],
        sort: true,
      },
      {
        dataField: 'project_id',
        text: [
          checkMot('id_projet'),
          <Bouton
            type={type_btn.lupeSearch}
            cliquer={() => afficherFiltre('project_id', checkMot('id_projet'))}
          >
            <VscSearch size={10} />
          </Bouton>,
        ],
        sort: true,
      },
      {
        dataField: 'template_id',
        text: [
          checkMot('template_id'),
          <Bouton
            type={type_btn.lupeSearch}
            cliquer={() =>
              afficherFiltre('template_id', checkMot('template_id'))
            }
          >
            <VscSearch size={10} />
          </Bouton>,
        ],
        sort: true,
      },
      {
        dataField: 'Xsensor_id',
        text: [
          checkMot('x_sensor_id'),
          <Bouton
            type={type_btn.lupeSearch}
            cliquer={() =>
              this.afficherFiltre('Xsensor_id', checkMot('x_sensor_id'))
            }
          >
            <VscSearch size={10} />
          </Bouton>,
        ],
        sort: true,
      },
      {
        dataField: 'Xcomponent_id',
        text: [
          checkMot('x_component_id'),
          <Bouton
            type={type_btn.lupeSearch}
            cliquer={() =>
              afficherFiltre('Xcomponent_id', checkMot('x_component_id'))
            }
          >
            <VscSearch size={10} />
          </Bouton>,
        ],
        sort: true,
      },
      {
        dataField: 'Ysensor_id',
        text: [
          checkMot('y_sensor_id'),
          <Bouton
            type={type_btn.lupeSearch}
            cliquer={() =>
              afficherFiltre('Ysensor_id', checkMot('y_sensor_id'))
            }
          >
            <VscSearch size={10} />
          </Bouton>,
        ],
        sort: true,
      },
      {
        dataField: 'Ycomponent_id',
        text: [
          checkMot('y_component_id'),
          <Bouton
            type={type_btn.lupeSearch}
            cliquer={() =>
              afficherFiltre('Ycomponent_id', checkMot('y_component_id'))
            }
          >
            <VscSearch size={10} />
          </Bouton>,
        ],
        sort: true,
      },
    ],

    selectRow: {
      // paramètre d'affichage des lignes du tableau
      mode: 'radio',
      clickToSelect: true,
      hideSelectAll: true,
      hideSelectColumn: true,
      style: () => {
        //style après sélection
        return {
          background: '#eeb214',
          color: 'black',
        };
      },
      onSelect: (row) => {
        //fonction de récupération des données de la ligne après sélection de la ligne
        return props.projetSelectione(row);
      },
    },

    iconeCreer: <VscNewFile size={15} />,
  };

  const [alarmListXY, setAlarmListXY] = useState([]);

  const getAlarmListXY = useCallback(
    async (providedPayload) => {
      let requestPayload = { list_project_id: [] };
      if (!providedPayload) {
        if (props.project_id_url) {
          requestPayload.list_project_id = parseInt(props.project_id_url);
        } else if (props.filtre_projects_list_id?.length > 0) {
          requestPayload.list_project_id = props.filtre_projects_list_id;
        }
      } else {
        requestPayload = { list_project_id: providedPayload };
      }
      try {
        const alarmList = await getAllAlarmsXYWithIdProject(requestPayload);
        if (alarmList.data.state) {
          setAlarmListXY(alarmList.data.list_alarms_xy);
        } else {
          console.error(
            'Erreur lors de la récupération des alarmes XY:',
            alarmList.data.errors
          );
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des alarmes XY:', error);
      }
    },
    [props.project_id_url, props.filtre_projects_list_id]
  );

  useEffect(() => {
    getAlarmListXY();
  }, [
    props.project_id_url,
    props.filtre_projects_list_id,
    props.interfaceAdmin,
    getAlarmListXY,
  ]);

  const afficherFiltre = (dataField, placeholder) => {
    const newCol = this.state.columns.map((col) => {
      if (col.dataField === dataField) {
        return {
          ...col,
          filter: textFilter({
            placeholder: placeholder,
          }),
        };
      } else {
        return col;
      }
    });
    this.setState({
      ...this.state,
      columns: [...newCol],
    });
  };

  const getListRowsToHide = () => {
    if (alarmListXY.length === 0) {
      return [];
    }

    return alarmListXY
      .filter((alarm) => {
        if (props.interfaceAdmin) {
          return !props.filtre_projects_list_id.includes(
            parseInt(alarm.project_id)
          );
        } else {
          return parseInt(alarm.project_id) !== parseInt(props.project_id_url);
        }
      })
      .map((alarm) => alarm.alarm_xy_id);
  };

  return (
    <>
      <Tableau
        cleLigne={'alarm_xy_id'}
        privilegeCreer={privilege.creer_des_alarmes}
        creer={props.creer}
        iconeCreer={tableConfig.iconeCreer}
        donnees={alarmListXY}
        colonnes={tableConfig.columns}
        selectionnerLignes={tableConfig.selectRow}
        lignesCache={getListRowsToHide()}
        defaultSorted={[
          {
            dataField: 'alarm_xy_id',
            order: 'desc',
          },
        ]}
      >
        <AttenteRequete
          request_type={
            requestType.recuperer_la_liste_des_configurations_des_alarmes_xy
          }
          str={checkMot('maj_alarme_xy_en_cour')}
        >
          <Bouton
            hoverText={checkMot('refresh')}
            type={type_btn.outil}
            rond={true}
            cliquer={() => {
              getAlarmListXY(props.filtre_projects_list_id);
            }}
          >
            <VscRefresh size={15} />
          </Bouton>
          {props.children}
        </AttenteRequete>
      </Tableau>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    interfaceAdmin: state.authentifie.interfaceAdmin,
    listeAlarmesXY: state.alarme.list_alarms_xy,
    filtre_projects_list_id: state.authentifie.filtre_projects_list_id,
    project_id_url: state.interfaceClient.project_id_url,
  };
};

export default connect(mapStateToProps)(TableauAlarmeXY);
